import { render, staticRenderFns } from "./UpdateFacilityModal.vue?vue&type=template&id=23c2acf3&scoped=true&"
import script from "./UpdateFacilityModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateFacilityModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateFacilityModal.vue?vue&type=style&index=0&id=23c2acf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2acf3",
  null
  
)

export default component.exports